import { Injectable, Injector } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { EvalService } from "./pages/eval/eval.service";

@Injectable()
export class EncounterInterceptor implements HttpInterceptor {
  /** EvalService depends on HttpClient, so it is resolved lazily to avoid a DI cycle. */
  constructor(private injector: Injector) {}

  // Endpoints that return encounter lists needing normalization
  private targetEndpoints = [
    "/get_all_reports",
    "/queue/",
    "/pending-",
    "/due-",
    "/completed-",
    "/past-due-",
    "/get-deposition",
    "/failed-evaluation",
    "/canceled-evaluation"
  ];

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Any successful write can change encounter/report data, so tabs must refetch
          // instead of reading the shared report cache.
          if (req.method !== "GET") {
            this.injector.get(EvalService).invalidateEncounterReportCache();
          }
          // Check if URL matches any target endpoint
          const isTargetUrl = this.targetEndpoints.some((endpoint) =>
            req.url.includes(endpoint)
          );

          if (isTargetUrl && event.body && Array.isArray(event.body.data)) {
            // Clone the body to avoid mutating the original immutable object directly (though usually safe in map)
            const modifiedBody = { ...event.body };
            modifiedBody.data = modifiedBody.data.map((item: any) => {
              // If encounterId is missing, alias the item itself as encounterId
              if (!item.encounterId) {
                console.log("Missing encounterId, populating it with item", item);
                return { ...item, encounterId: item };
              }
              return item;
            });

            return event.clone({ body: modifiedBody });
          }
        }
        return event;
      })
    );
  }
}
